
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/azienda/tecnologie",
      function () {
        return require("private-next-pages/azienda/tecnologie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/azienda/tecnologie"])
      });
    }
  